import type { ChatboxStore } from "../store";
import { useChannelEvent } from "@/components/realtime";
import { useMemo } from "react";

export const useListenEvents = (store: ChatboxStore) => {
  const {
    use: { options },
    bind: { stopStatusTracking, checkRuntimeStatus },
  } = store;

  const realtimeChannel = useMemo(() => {
    if (options?.conversation) {
      return `conversation._.${options.conversation.uid}`;
    }
    return "";
  }, [options?.conversation]);

  useChannelEvent(realtimeChannel, "runtime_completed", () => {
    stopStatusTracking();
  });

  useChannelEvent(realtimeChannel, "node_change", () => {
    checkRuntimeStatus();
  });
};
